export default __webpack_public_path__ + "static/media/nabh.901439fd.png";